__turbopack_context__.v({
  "search-type-filter": "Ol5tFa_search-type-filter",
});
